import { Fragment } from 'react';

import { NsList } from 'components/common/ns-list/NsList';
import { useExitFeeValue } from 'components/direct-sales/quote/hooks/useExitFees';
import {
  getTariffEndDate,
  formatTariffDate
} from 'components/direct-sales/quote/utils';
import { usePaymentMethod } from 'hooks/usePaymentMethod';
import { useTariffType } from 'components/direct-sales/quote/hooks/useTariffType';
import { NsAnchor } from 'components/common/ns-anchor/NsAnchor';

type TariffFeaturesProps = {
  product: object;
};

export const TariffFeatures = ({ product }: TariffFeaturesProps) => {
  const { isFixed, isVariable, isTracker } = useTariffType(product);
  const tariffEndDate = getTariffEndDate(product);
  const formatTariffEndDate = formatTariffDate(tariffEndDate);
  const { paymentName } = usePaymentMethod();
  const { short: exitFeeValue, details: exitFeeDetails } = useExitFeeValue(
    product
  );

  return (
    <>
      <NsList>
        {[
          isFixed && 'Fixed tariff with rates and charges that won’t increase',
          isVariable &&
            'Rates and charges that could go up or down. Ofgem price cap applies.',
          isTracker && (
            <>
              This works like our variable tariff which tracks the{' '}
              <NsAnchor href="https://www.britishgas.co.uk/energy/price-cap.html#svt">
                Ofgem price cap
              </NsAnchor>{' '}
              so your rate and charges may go up or down in time with the price
              cap
            </>
          ),
          tariffEndDate && `Tariff ends on ${formatTariffEndDate}.`,
          paymentName,
          <>Exit fee: {exitFeeValue}</>
        ]
          .filter((f) => f)
          .map((feature, index) => (
            <Fragment key={index}>{feature}</Fragment>
          ))}
      </NsList>
      {exitFeeDetails && (
        <p className="p-small">
          <b>{exitFeeDetails}</b>
        </p>
      )}
    </>
  );
};
